import { render } from "./CompanyBusinessCardSealForm.vue?vue&type=template&id=1d7cba7d&ts=true"
import script from "./CompanyBusinessCardSealForm.vue?vue&type=script&lang=ts"
export * from "./CompanyBusinessCardSealForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__